import { TFunction } from "i18next";
import { HelpFAQAnswerWrapper } from "../../pages/Help/Help.styles";
import { AccordionProps } from "../shared/Accordion/Accordions";
import { GetTypographyContent } from "../shared/Typography/Typography";

export const getUpfrontPaymentAccordionData = (
  t: TFunction,
): AccordionProps[] => [
  {
    title: t("upfrontPayment.faq.openBalance.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("upfrontPayment.faq.openBalance.body"),
          size: "medium",
        })}
      </HelpFAQAnswerWrapper>
    ),
    key: "openBalance",
  },
  {
    title: t("upfrontPayment.faq.insuranceCover.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("upfrontPayment.faq.insuranceCover.body"),
          size: "medium",
        })}
      </HelpFAQAnswerWrapper>
    ),

    key: "insuranceCover",
  },
  {
    title: t("upfrontPayment.faq.itemizedBill.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("upfrontPayment.faq.itemizedBill.body"),
          size: "medium",
        })}
      </HelpFAQAnswerWrapper>
    ),

    key: "itemizedBill",
  },
  {
    title: t("upfrontPayment.faq.fullAmount.title"),
    content: (
      <HelpFAQAnswerWrapper>
        {GetTypographyContent({
          content: t("upfrontPayment.faq.fullAmount.body"),
          size: "medium",
        })}
      </HelpFAQAnswerWrapper>
    ),

    key: "fullAmount",
  },
];
